import type { WindowDescriptor } from '@krp/client-runtime'
import type { ReceiptsUiState } from '../../reducer'

export const OWN_JOURNAL_WINDOWS = { detail: 'receipts.ownJournal.detail' } as const
/** Адрес детали чека отдаёт служба Receipts в `originalPath` — путь здесь и там один. Списка чеков здесь нет: чеки смотрят в статистике по продажам. */
export const ownJournalWindows: readonly WindowDescriptor<ReceiptsUiState>[] = [
  { kind: OWN_JOURNAL_WINDOWS.detail, scope: 'resource', paths: ['/receipts-service/resources/:rid/receipts/:id'], label: 'Собственный чек', size: 'lg', section: { id: 'receipts' } },
]
